/*
  Project: Starter Test
  Author: Michał Strześniewski
 */

import inputs from './modules/inputs';
import slider from './modules/slider';
// import carousel from './modules/carousel';
import accordion from './modules/accordion';
import anchormenu from './modules/anchormenu';
import defaultslider from './modules/defaultslider';
import filterform from './modules/filterform';
import showmore from './modules/show-more';
import visiblepopup from './modules/visiblepopup';
import innerContentFilter from './modules/inner-content-filter';
import selectedlink from './modules/selectedlink';
import pagination from './modules/pagination';
import menu from './modules/menu';
import checkedUrlParams from './modules/checkedUrlParams';
import popupform from './modules/popupform';
import rollContent from './modules/roll-content';
import searchInTeam from './modules/search-in-team';
import cookies from './modules/cookies';
import applyPopup from './modules/applyPopup';
import search from './modules/search';
import grid from './modules/grid';
import studentsPopup from './modules/studentsPopup';
import gallery from './modules/gallery';
import wowAnimate from './modules/wowAnimate';
import moreText from './modules/moreText';
import customScroll from './modules/customscroll';
import homeLinksInNewTabs from './modules/homeLinksInNewTabs';
import wpcf7 from './modules/wpcf7';
import wcag from './modules/wcag';

const init = () => {
  inputs();
  slider();
  accordion();
  anchormenu();
  defaultslider();
  filterform();
  showmore();
  visiblepopup();
  innerContentFilter();
  selectedlink();
  wcag();
  grid();
  pagination();
  menu();
  checkedUrlParams();
  popupform();
  rollContent();
  searchInTeam();
  cookies();
  applyPopup();
  search();
  studentsPopup();
  gallery();
  wowAnimate();
  moreText();
  customScroll();
  homeLinksInNewTabs();
  wpcf7();
};

document.addEventListener('DOMContentLoaded', () => {
  init();
});
/* eslint-disable */
// history.scrollRestoration = 'manual';
/* eslint-enable */



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/app.js